'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { CarouselTrack } from '@/src/components/features/property/ui/Carousel/CarouselTrack';
import { CarouselItem } from '@/src/components/features/property/ui/Carousel/CarouselItem';
import { CarouselIndicators } from '@/src/components/features/property/ui/Carousel/CarouselIndicators';
import { useCarouselNavigation } from '@/src/components/features/property/ui/Carousel/hooks/useCarouselNavigation';
import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { FloorPlanCard } from './FloorPlanCard';
import type { Floorplan, Unit } from './UnitTable';
import * as styles from './unitsModule.styles';

type MobileFloorPlanCarouselProps = {
  floorplans: Array<Floorplan>;
  listing: PropertyDetailListing;
  onUnitSelect: (unit: Unit, floorplan: Floorplan) => void;
  onSeeAll: (floorplan: Floorplan) => void;
};

export const MobileFloorPlanCarousel = ({
  floorplans,
  listing,
  onUnitSelect,
  onSeeAll,
}: MobileFloorPlanCarouselProps) => {
  const t = useTranslations('hdp');
  const { trackRef, currentPage, totalPages, scrollToPage, handleScroll } = useCarouselNavigation({
    gap: 'md',
    step: 'page',
  });

  return (
    <>
      <CarouselTrack ref={trackRef} gap="md" snapAlign="start" onScroll={handleScroll} aria-label={t('floorPlans')}>
        {floorplans.map((fp) => (
          <CarouselItem key={fp.modelId} className={styles.mobileCarouselItem}>
            <FloorPlanCard floorplan={fp} listing={listing} onUnitSelect={onUnitSelect} onSeeAll={onSeeAll} />
          </CarouselItem>
        ))}
      </CarouselTrack>

      {floorplans.length > 1 && (
        <div className={styles.dotContainer}>
          <CarouselIndicators currentPage={currentPage} totalPages={totalPages} onPageSelect={scrollToPage} />
        </div>
      )}
    </>
  );
};
